import clsx from 'clsx';
import styles from './styles.module.scss';

export function ContentsHeader({
  title,
  description = '',
  actions = null,
  className,
}: {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={clsx(styles.Header, className)}>
      <div className={styles.Header__TitleContainer}>
        <h1 className={styles.Header__Title}>{title}</h1>
        {description && <div className={styles.Header__Description}>{description}</div>}
      </div>
      <div className={styles.Header__Actions}>{actions}</div>
    </div>
  );
}
